// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { AskGetabstractAnalyticsFeedbackEventForm } from "../schema";

export function serialize_AskGetabstractAnalyticsFeedbackEventForm_internal(value: AskGetabstractAnalyticsFeedbackEventForm): unknown {
  return ((value: { isPositive: boolean; questionUuid: string }): unknown => {
    return {
      isPositive: ((value: boolean): unknown => {
        return value;
      })(value["isPositive"]),
      questionUuid: ((value: string): unknown => {
        return value;
      })(value["questionUuid"]),
    };
  })(value);
}
export function serialize_AskGetabstractAnalyticsFeedbackEventForm(obj: AskGetabstractAnalyticsFeedbackEventForm): string {
  return renderJsonWithNumbersAsBigint(serialize_AskGetabstractAnalyticsFeedbackEventForm_internal(obj));
}
export function deserialize_AskGetabstractAnalyticsFeedbackEventForm_internal(value: unknown): ParserResult<AskGetabstractAnalyticsFeedbackEventForm> {
  return ((
    value: unknown,
  ): ParserResult<{
    isPositive: boolean;
    questionUuid: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/AskGetabstractAnalyticsFeedbackEventForm]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractAnalyticsFeedbackEventForm]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "isPositive")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractAnalyticsFeedbackEventForm/isPositive]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'isPositive'.` };
    }
    const parsed_isPositive = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/AskGetabstractAnalyticsFeedbackEventForm/isPositive]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["isPositive"]);
    })();
    if (!parsed_isPositive.success) {
      return { success: false, reason: parsed_isPositive.reason };
    }
    if (!hasProp(value, "questionUuid")) {
      return { success: false, reason: `[#/components/schemas/AskGetabstractAnalyticsFeedbackEventForm/questionUuid]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'questionUuid'.` };
    }
    const parsed_questionUuid = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/AskGetabstractAnalyticsFeedbackEventForm/questionUuid]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["questionUuid"]);
    })();
    if (!parsed_questionUuid.success) {
      return { success: false, reason: parsed_questionUuid.reason };
    }
    return { success: true, value: { isPositive: parsed_isPositive.value, questionUuid: parsed_questionUuid.value } };
  })(value);
}
export function deserialize_AskGetabstractAnalyticsFeedbackEventForm(str: string): ParserResult<AskGetabstractAnalyticsFeedbackEventForm> {
  return deserialize_AskGetabstractAnalyticsFeedbackEventForm_internal(parseJsonWithNumbersAsBigint(str));
}
